export default __webpack_public_path__ + "static/media/white_logo.baab5df7.svg";